<!-- Signup Form Card -->
<div class="signup-form-card">
  <div class="card-content">
    <form
      [formGroup]="signupForm"
      (ngSubmit)="onSubmit()"
      class="signup-form"
    >
      <p class="signup-form-lead">
        You'll receive major project updates, a short survey, and an opportunity
        to apply to be a beta tester
      </p>
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-input"
          [class.error]="
            signupForm.get('email')?.invalid &&
            signupForm.get('email')?.touched
          "
          placeholder="Enter your email"
          autocomplete="email"
        />
        @if ( signupForm.get('email')?.invalid &&
        signupForm.get('email')?.touched ) {
        <div class="error-message">
          @if (signupForm.get('email')?.errors?.['required']) {
          <span>Email is required</span>
          } @if (signupForm.get('email')?.errors?.['pattern']) {
          <span>Please enter a valid email address</span>
          }
        </div>
        }
      </div>

      <button
        type="submit"
        class="submit-btn"
        [disabled]="signupForm.invalid || isLoading"
      >
        @if (!isLoading) {
        <span>Join the Waitlist</span>
        } @if (isLoading) {
        <span class="loading-spinner">Applying...</span>
        }
      </button>
      <div class="signup-privacy-note" role="note">
        <p class="signup-privacy-note__line">We care about your data at all levels.</p>
        <p class="signup-privacy-note__line">
          Your email will never be sold and never get spam from us.
        </p>
      </div>
    </form>

    <!-- Error Message -->
    @if (errorMessage) {
    <div class="error-message-global">
      <div class="error-icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#ff4444"
            stroke-width="2"
          />
          <path
            d="m15 9-6 6m0-6 6 6"
            stroke="#ff4444"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p>{{ errorMessage }}</p>
    </div>
    }
  </div>
</div>
